// *** Login Component ****
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Modal } from "react-bootstrap";
import SignUp from "./SignUp";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import eyeoff from "../../assets/img/eye-off.png";
import faq from "../../assets/img/landing/faq.svg";
import facebook from "../../assets/img/landing/fb.svg";
import contact from "../../assets/img/landing/contact.svg";
import termicon from "../../assets/img/terms-con.svg";
import tourIcon from "../../assets/icons/TourIcon.svg";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import { Link } from "react-router-dom";
import Validation from "../../commonComponents/Validation";
import swal from 'sweetalert';
import Cookies from 'js-cookie';
import Spinner from "../../commonComponents/Spinner";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import ContactUs from "../OtherLinks/ContactPopup";
import Faq from "../OtherLinks/FaqPopup";
import { useGoogleLogin } from '@react-oauth/google';
import PrivacyPopup from "../OtherLinks/PrivacyPopup";
import TermsPopup from "../OtherLinks/TermsPopup";
import GuidedTourPopUp from "../OtherLinks/GuidedTourPopUp";
import playstore from "../../assets/img/playstore.png";
import appstore from "../../assets/img/appstore.png";



const Login = () => {
  const Group = require("../../assets/img/logo.png");
  const google = require("../../assets/img/Social icon.png");
  const apple = require("../../assets/img/path4.png");
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(false);
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [socialId, setSocialId] = useState('');
  const [socialType, setSocialType] = useState('');
  const [password, setPassword] = useState('');
  const handleClose = () => setIsSignUp(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [stayLoggedIn, setStayLoggedIn] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [isSucess, SetSucess] = useState(false);
  const [open, setOpen] = useState(false);
  const [faqopen, setFaqOpen] = useState(false);
  const [privacyopen, setPrivacyOpen] = useState(false);
  const [guidedTouropen, setGuidedTourOpen] = useState(false);
  const [termsopen, setTermsOpen] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const [videoArr, setVideoArr] = useState([]);
// Auto-open popup based on query parameter
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const show = params.get("show");

  if (show === "privacy-policy" || show === "privacy") {
    setPrivacyOpen(true);  // open popup automatically
  }
  if (show === "terms") {
    setTermsOpen(true);
  }
  if (show === "faq") {
    setFaqOpen(true);
  }
  if (show === "contact") {
    setOpen(true);
  }
}, []);

  useEffect(() => {
  const token = Cookies.get('authToken') || sessionStorage.getItem('authToken');
  if (token) {
    navigate('/justlikeme');
  } else {
    setIsCheckingAuth(false);
  }

  if (!document.getElementById("facebook-jssdk")) {
    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      // Init only after the SDK is fully loaded
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v18.0",   // ✅ correct format
      });
    };
    document.body.appendChild(script);
  }
}, []);


  const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);

  }

  const FaqOpenPopup = () => {
    setFaqOpen(true);
  }
  const FaqClosePopup = () => {
    setFaqOpen(false);

  }
  const PrivacyOpenPopup = () => {
    setPrivacyOpen(true);
  }
  const PrivacyClosePopup = () => {
    setPrivacyOpen(false);

  }
  const TermsOpenPopup = () => {
    setTermsOpen(true);
  }
  const TermsClosePopup = () => {
    setTermsOpen(false);

  }
  const GuidedTourOpenPopup = () => {
    setGuidedTourOpen(true);
  }
  const GuidedTourClosePopup = () => {
    setGuidedTourOpen(false);

  }


  const handleSignUpSuccess = (responseData) => {
    setIsSignUpSuccess(responseData)
    setIsSignUp(true);
  };

  const handleLoginPage = () => {
    setIsSignUpSuccess(true);
    setError(false)
  }

  
    useEffect(() => {
      fetchGuidedTour()
    }, [])
  
    const fetchGuidedTour = async () => {
  
     await ApiHelper.get(API.getSiteSettings)
               .then((resData) => {
                   setVideoArr(resData.data)
               })
               .catch((err) => {
                 console.log(err, 'err');
               });
  
  
    }
    const getEmbedUrl = (url) => {
    let videoUrl = null;
   const videoId = getYouTubeVideoId(url);
        if (videoId) {
          videoUrl = `https://www.youtube.com/embed/${videoId}`;
        }
        return videoUrl
};
const getYouTubeVideoId = (url = "") => {
  if (!url || typeof url !== "string") return null;

  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

  const match = url.match(regExp);

  return match && match[2] && match[2].length === 11 ? match[2] : null;
};
  const handleLogin = async () => {
    setLoader(true);
    if (email !== "" && password !== "") {
      setError(false)
      
      const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-zA-Z0-9\-]+(\.[a-zA-Z]{2,5})+/g;
      const result = pattern.test(email);
      if (result === false) {
        setEmailError(true)
      } else {
        setEmailError(false)
        const formData = {
          email: email,
          password: password,
        };
        await ApiHelper.post(API.login, formData)
          .then((resData) => {
            localStorage.setItem('userData', JSON.stringify(resData.data.data));
            localStorage.setItem('userToken', resData.data.token);
            localStorage.setItem('userCommunities', JSON.stringify(resData.data.userCommunities));
            if (resData.data.token) {
              if (stayLoggedIn) {
                Cookies.set('authToken', resData.data.token, { expires: 30, path: '/' });
              } else {
                sessionStorage.setItem('authToken', resData.data.token);
              }
            }
            if (resData.data.status) {
              if (resData.data.data.userType === "organization") {

                navigate('/discussions');

              } else {
                navigate('/justlikeme');
              }

            }
            else {
              SetSucess(true);
              SetResponseMessage(resData.data.message);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err, 'err');
          });
      }
    } else {
      setLoader(false);
      setError(true);
    }
  }

 const googleLogin = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    try {
      const res = await fetch(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        }
      );
      const userInfo = await res.json();
     

      const formData = {
          id: userInfo.sub,
          type: 'google',
          email: userInfo.email
        };
        await ApiHelper.post(API.socialMediaLogin, formData)
          .then((resData) => {
            
            localStorage.setItem('userData', JSON.stringify(resData.data.data));
            localStorage.setItem('userToken', resData.data.token);
            localStorage.setItem('userCommunities', JSON.stringify(resData.data.userCommunities));
            if (resData.data.token) {
              if (stayLoggedIn) {
                Cookies.set('authToken', resData.data.token, { expires: 30, path: '/' });
              } else {
                sessionStorage.setItem('authToken', resData.data.token);
              }
            }
            if (resData.data.status) {
              if (resData.data.data.userType === "organization") {

                navigate('/discussions');

              } else {
                navigate('/justlikeme');
              }

            }
            else {
              handleEmailVerification(userInfo.email, userInfo.name, userInfo.sub)
            }
          })
          .catch((err) => {
            setLoader(false);

            console.log(err, 'err');
          });


      
    } catch (err) {
      console.error("❌ Error fetching user info:", err);
    }
  },
  onError: (err) => {
    console.error("❌ Google Login Failed:", err);
  },
});

const handleFacebookLogin = () => {
  if (!window.FB) {
    console.error("❌ Facebook SDK not loaded yet");
    return;
  }

  window.FB.login(
    function (response) {
      if (response.authResponse) {
        

        window.FB.api("/me", { fields: "id,name,email,picture" }, async function (userInfo) {
         

          // Send to your API
          const formData = {
            id: userInfo.id,
            type: "facebook",
            email: userInfo.email || "", // sometimes missing
          };

          try {
            const resData = await ApiHelper.post(API.socialMediaLogin, formData);

            if (resData.data.status) {
              localStorage.setItem("userData", JSON.stringify(resData.data.data));
              localStorage.setItem("userToken", resData.data.token);
              localStorage.setItem("userCommunities", JSON.stringify(resData.data.userCommunities));

              if (resData.data.token) {
                if (stayLoggedIn) {
                  Cookies.set("authToken", resData.data.token, { expires: 30, path: "/" });
                } else {
                  sessionStorage.setItem("authToken", resData.data.token);
                }
              }

              navigate(resData.data.data.userType === "organization"
                ? "/discussions"
                : "/justlikeme"
              );
            } else {
              // Not registered → open signup
              setIsSocial(true);
              setIsSignUp(true);
              setEmail(userInfo.email || "");
              setName(userInfo.name);
              setSocialId(userInfo.id);
              setSocialType("facebook");
            }
          } catch (err) {
            console.error("❌ Error saving FB user:", err);
          }
        });
      } else {
        console.log("❌ FB Login cancelled or failed");
      }
    },
    { scope: "public_profile,email" }
  );
};
const handleEmailVerification = async (mailId, name, subId) => {
        const value = mailId;
            const formData = {
                email: value
            }
            await ApiHelper.post(API.checkEmailExist, formData)
                .then((resData) => {
                  if(resData.data.status){
                    SetResponseMessage(resData.data.message)
                    SetSucess(true)
                  }
                  else{
                    setIsSocial(true);
                    setIsSignUp(true);
                    setEmail(mailId);
                    setName(name);
                    setSocialId(subId);
                    setSocialType('google')
                  }
                })
                .catch((err) => {
                    console.log(err);
                })
        
    }




  return (
    <div className="mainpage">
      <ul className="faq-contact">
        <li>
          <a href="#faq" className="text-blue-600 hover:text-blue-800 transition" onClick={() => { FaqOpenPopup() }}>

            <img src={faq} className="logo Centered Image comp-logo"  ></img>

            FAQ
          </a>
        </li>
        |
        <li>
          <a href="#contact" className="text-blue-600 hover:text-blue-800 transition" onClick={() => { OpenPopup() }}>

            <img src={contact} className="logo Centered Image comp-logo"  ></img>

            Contact Us
          </a>
        </li>
         |
        <li>
          <a href="#terms-and-condiyion" className="text-blue-600 hover:text-blue-800 transition" onClick={() => { TermsOpenPopup() }}>

            <img src={termicon} className="logo Centered Image comp-logo"  ></img>

            Terms and Condition
          </a>
        </li>
         |
        <li>
          <a href="#privacy" className="text-blue-600 hover:text-blue-800 transition" onClick={() => { PrivacyOpenPopup() }}>

            <img src={termicon} className="logo Centered Image comp-logo"  ></img>

            Privacy Policy
          </a>
        </li>
        |
        <li>
          <a href="#guided-tour" className="text-blue-600 hover:text-blue-800 transition" onClick={() => { GuidedTourOpenPopup() }}>

            <img src={tourIcon} className="logo Centered Image comp-logo"  ></img>

            Guided Tour
          </a>
        </li>
      </ul>


      {isCheckingAuth && <Spinner />}
      <div class="container-fluid">
        <div class="login-row">
          <div class="details-login">
            <div className="log-img ">
              <img src={Group} className="logo Centered Image comp-logo"  ></img></div>
            <div className="tagline mb-2 text-center taglins-main">
              <span className="strongs-h main-tag">People Just Like You, Stories Like Yours</span>
              <p className=" first-cont text-center sub-tag">A social health platform for
                sharing experiences, <br></br>
                finding
                support, and making a
                difference</p></div>

            {/* <video controls poster="" className="videosize">
              <source src="your-video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
            <div className="">
               <iframe
                  className="videosize"
                  src={`${getEmbedUrl(videoArr.marketingVideoUrl)}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
            </div>
            

          </div>


          <div class="form-sec">
            <div className="form-box shadow formboxwidth ">
              <h5 className="mb-2 freeaccount">Create your Free account</h5>
              <ul className="list-unstyled  mb-3">
                <li className="text-success mb-1 login-fea">✔ <span className="points"> Join a Community of People Like You</span></li>
                <li className="text-success mb-1 login-fea">✔ <span className="points"> Learn from People Like You</span></li>
                <li className="text-success mb-1 login-fea">✔ <span className="points"> Share your experiences and help others</span></li>
              </ul>
              {isSignUpSuccess ?
                <form className="dh-form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                  <div className="email-dh">
                    <input type="email" className="form-control text-light" placeholder="Enter your email"
                      onChange={(e) => { setEmail(e.target.value) }} value={email} />
                    {emailError && <Validation message={'Please enter valid email'} />}
                    {email === "" && error ? (
                      <Validation message={'Please enter email'} />
                    ) : null}
                  </div>
                  <div className="position-relative pass-dh">
                    <input type={showPassword ? "text" : "password"} className="form-control pe-5" placeholder="Enter your password"
                      onChange={(e) => { setPassword(e.target.value) }} value={password} />
                    <i
                      className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'} mt-3 eye-icon password-icon`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                    {password === "" && error ? (
                      <Validation message={'Please enter password'} />
                    ) : null}
                  </div>
                  <div className="">
                    <Link to='/forgot-password' className="text-decoration-none small  txt-color">Forgot Password ?</Link>
                  </div>
                  <div className="">
                    <p className="sty-logg">
                      <input type="checkbox" name="payment" id="vessels"
                        className="vesselradio form-check-input radiobtn"
                        onChange={(e) => { setStayLoggedIn(e.target.checked) }} checked={stayLoggedIn} />
                      Stay logged in for 30 days. </p>
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn text-dark logbtn">Login</button>
                  </div>
                  <div className="d-grid">
                    <button type="button" className="btn btn-teal text-white signupbtn" onClick={() => setIsSignUp(true)}>Sign Up</button>
                  </div>
                  <div className="text-center mb-1">OR</div>
                  <div className="d-grid socialwrapper">
                    <button type="button" class="social-button" onClick={(e) => { e.preventDefault(); googleLogin(); }}>
                      <img src={google} className="" ></img>
                      Sign up with Google
                    </button>
                    <div class="social-button apple d-none" >
                      <img src={apple} className="" ></img>
                      Sign up with Apple
                    </div>
                    <div class="social-button facebook d-none" onClick={(e) => { e.preventDefault(); handleFacebookLogin(); }}>
                      <img src={facebook} className="" ></img>
                      Sign up with Facebook
                    </div>
                  </div>

                </form> :
                <form className="dh-form" >
                  <div className="d-grid socialwrapper">
                    <div class="social-button" onClick={(e) => { e.preventDefault(); googleLogin(); }}>
                      <img src={google} className="" ></img>
                      Sign up with Google
                    </div>
                    <div class="social-button apple d-none">
                      <img src={apple} className="" ></img>
                      Sign up with Apple
                    </div>
                    <div class="social-button facebook d-none" onClick={(e) => { e.preventDefault(); handleFacebookLogin(); }}>
                      <img src={facebook} className="" ></img>
                      Sign up with Facebook
                    </div>
                  </div>
                  <div className="text-center or-log">OR</div>
                  <>
                    <div className="d-grid">
                      <button type="button" className="btn btn-teal text-white signupbtn" onClick={() => setIsSignUp(true)}>Sign Up</button>
                    </div>
                    <div className="d-grid">
                      <button type="button" className="btn text-dark logbtn" onClick={() => handleLoginPage()}>Login</button>
                    </div>

                  </>

                </form>}
            </div>
          </div>

          <div className="only_mob">
            <h6>To access Dreamers Health to find a Community of people just like you on your mobile device please download the app</h6>
            <div className="download">
              <div className="appstore">
                  <Link to="https://apps.apple.com/in/app/dreamers-health/id6758043431" download>
                    <img src={appstore} className="" ></img>
                  </Link>
              </div>

              <div className="appstore">
                  <Link to="https://play.google.com/store/apps/details?id=com.dreamershealthapp" download>
                    <img src={playstore} className="" ></img>
                  </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
      {isSignUp ? <SignUp isSignUp={isSignUp} handleClose={handleClose} onSignUpSuccess={handleSignUpSuccess} isSocial={isSocial} socialMail={email} socialName={name} socialId={socialId} socialType={socialType} /> : null}
      <ContactUs openPop={open} closePop={ClosePopup}></ContactUs>
      <Faq FaqOpenPopup={faqopen} FaqClosePopup={FaqClosePopup}></Faq>
      <PrivacyPopup privacyOpenPopup={privacyopen} privacyClosePopup={PrivacyClosePopup} />
      <TermsPopup termsOpenPopup={termsopen} termsClosePopup={TermsClosePopup} />
      <GuidedTourPopUp guidedTouropen={guidedTouropen} GuidedTourClosePopup={GuidedTourClosePopup}/>
      {isSucess && (<ResponsePopup
        isSucess={isSucess}
        CancelPopup={() => {
          SetSucess(false);
        }}
        message={ResponseMessage}
      />)}
    </div>
  );
};
export default Login;
